import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import RequestApi from './RequestApi';


class BotaoDeletar extends Component {

  // constructor
  constructor(props) {
    super(props);
    this.state = {
      url: this.props.url,
      dados: [],
    }
    this.deletar = this.deletar.bind(this);
  }

  deletar(){
    var url = config.get('api') + this.state.url;
    fetch(url, {method: 'DELETE', mode: 'cors', headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      this.refs.request_api.validate(responseJson);
      this.setState({
        dados: responseJson.data,
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <button className="btn btn-danger btn-sm" value={this.state.url} onClick={this.deletar}>
          <i className="fa fa-fw fa-trash"></i>
        </button>        
      </div>
    );
  }
}

export default BotaoDeletar;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/BotaoDeletar.js